module.exports = __webpack_public_path__ + "media/images/dashboard/dark/tile_icon_call_map-cddfcaddfb64860c736b6d254937a7f7.png";